import { seatsManager } from "./seats_manager.js";

var showTicketsTypeAndStateInputs = function (config, flag) {
  var $availableTicketsBlock = config.$form.find(".available-selects");
  if (flag) {
    $availableTicketsBlock.show();
    config.submitBtn.prop("disabled", false);
  } else {
    $availableTicketsBlock.hide();
    config.submitBtn.prop("disabled", true);
  }
};

export let selectedSeatsManager = (window.selectedSeatsManager = seatsManager({
  initialize: function (config) {
    // Admin functionality for assigning seat type and state
    var $availableSelects = config.$form.find(".available-selects");
    var ticketTypeLabels = JSON.parse(
      config.$form.attr("data-lang-ticket-types")
    );
    var ticketTypeStates = JSON.parse(
      config.$form.attr("data-lang-ticket-states")
    );
    if ($availableSelects.children().length === 0) {
      // create html for ticket state select
      var selectTicketState = $(
        "<select name='ticket-state' class='seat-states-select'></select>"
      );

      // create html for ticket types select
      var selectSeatType = $(
        "<select name='ticket-types' class='seat-types-select'></select>"
      );

      // create html for price zones select
      var selectPriceZone = $(
        "<select name='price-zones' class='price-zones-select'></select>"
      );

      $("<option value=''></option>").appendTo(selectSeatType);
      for (var index in config.data.types) {
        $(
          "<option value='" +
            index +
            "'>" +
            ticketTypeLabels[index] +
            "</option>"
        ).appendTo(selectSeatType);
      }

      config.$form.on("change", ".seat-types-select", function (e) {
        var currentItemType = e.target.value
          ? config.data.types[e.target.value]
          : {};
        selectTicketState.empty();
        for (var i = 0; i < currentItemType.length; i++) {
          $(
            "<option value='" +
              currentItemType[i] +
              "'>" +
              ticketTypeStates[currentItemType[i]] +
              "</option>"
          ).appendTo(selectTicketState);
        }
      });

      $("<option value=''></option>").appendTo(selectPriceZone);
      for (var i = 0; i < config.data.price_zones.length; i++) {
        $(
          "<option value='" +
            config.data.price_zones[i].id +
            "'>" +
            config.data.price_zones[i].name +
            "</option>"
        ).appendTo(selectPriceZone);
      }

      $availableSelects
        .append(
          $(
            "<div class='available-selects__header'>" +
              config.$form.attr("data-lang-ticket-type") +
              "</div>"
          )
        )
        .append(selectSeatType)
        .append(
          $(
            "<div class='available-selects__header'>" +
              config.$form.attr("data-lang-ticket-state") +
              "</div>"
          )
        )
        .append(selectTicketState);

      $availableSelects
        .append(
          $(
            "<div class='available-selects__header'>" +
              config.$form.attr("data-lang-price-zone") +
              "</div>"
          )
        )
        .append(selectPriceZone);

      selectSeatType
        .val(selectSeatType.find("option:eq(0)").val())
        .trigger("change");
    }

    config.ticketsList.children().length === 0 &&
      showTicketsTypeAndStateInputs(config, false);
    config.ticketsList.children().length > 0 &&
      showTicketsTypeAndStateInputs(config, true);

    // listen for a click event on remove button
    config.$form.on("click", "em", function (event) {
      var ticket = $(event.target).parents("li");
      config.actions.remove(ticket.data("row"), ticket.data("coll"));
    });

    // Go to the next step by submitting form or changing tickets
    config.$form.submit(function (event) {
      var data = {};
      var sectionId = config.$form.attr("data-section-id");
      var ticketsResult = [];
      var areasResult = [];
      var ticketTypesVal = config.$form.find(".seat-types-select").val();
      var ticketStateVal = config.$form.find(".seat-states-select").val();
      var ticketPriceZoneIdVal = config.$form.find(".price-zones-select").val();

      for (var index in config.tickets) {
        var ticket = config.tickets[index];
        if (
          ticket.data("row") !== undefined &&
          ticket.data("coll") !== undefined
        ) {
          if (typeof ticket.data("area_uuid") !== "undefined") {
            areasResult = areasResult.concat([
              {
                section_id: sectionId,
                type: ticketTypesVal,
                status: ticketStateVal,
                price_zone_id: ticketPriceZoneIdVal,
                area_uuid: ticket.data("area_uuid"),
              },
            ]);
          } else {
            ticketsResult = ticketsResult.concat([
              {
                section_id: sectionId,
                row: ticket.data("row"),
                seat: ticket.data("coll"),
                type: ticketTypesVal,
                status: ticketStateVal,
                price_zone_id: ticketPriceZoneIdVal,
              },
            ]);
          }
        }
      }

      $.ajax({
        url: this.action,
        data: $.param({
          seats: ticketsResult,
          areas: areasResult,
        }),
        type: "PATCH",
      })
        .done(function (data) {
          window.location.reload();
        })
        .fail(function (data) {
          config.$form
            .closest(".content")
            .prepend(
              $(
                "<div class='alert alert-error alert-block'>" +
                  JSON.parse(data.responseText).message +
                  "</div>"
              )
            );
        });

      return false;
    });
  },
  add: function (config, row, coll, type, itemTypes, uuid) {
    var ticketHtml = config.ticketFieldTemplateSelected(row, coll);
    config.tickets[row + "||" + coll] = $(ticketHtml)
      .append(config.ticketTypeSelector)
      .hide()
      .appendTo(config.ticketsList)
      .slideDown(200)
      .data("row", row)
      .data("coll", coll)
      .data("area_uuid", uuid);

    config.$form
      .find(".tickets-amount em")
      .html(config.ticketsList.children().length);

    config.ticketsList.children().length > 0 &&
      showTicketsTypeAndStateInputs(config, true);

    config.$form.find(".ticket-types-select").val(type).change();
  },
  remove: function (config, row, coll) {
    var ticket = $(config.tickets[row + "||" + coll]);
    if (ticket.length > 0) {
      ticket.fadeOut(200, function () {
        $(this).remove();
        // update tickets amount
        config.$form
          .find(".tickets-amount em")
          .html(config.ticketsList.children().length);
        config.ticketsList.children().length === 0 &&
          showTicketsTypeAndStateInputs(config, false);
      });

      config.$form.trigger("seat:remove", [[row, coll]]);
    }
  },
}));
